<template>
  <div class="service-session flex flex-column">
    <chat-header
      :show-type="props.showType"
      :style-config="props.serviceStyle"
      :round="page.msgRound"
      :close-session-enable="props.closeSessionEnable"
      :robot-enable="props.robotEnable"
      :session-status="page.sessionStatus"
      :seerFlag="page.seerFlag"
      @comment="openComment"
      @switchRobot="switchRobot"
      @quit="closeSession"
      @switch="changeSwitch"
    />
    <chat-msg
      ref="chatMsgRef"
      :style-config="props.serviceStyle"
      :chat-msg="chatMsg"
      :show-type="props.showType"
      :orgId="props.appInfo.orgId"
      :comment-type="page.inviteType"
      :agent-info="page.agentInfo"
      @loadHistory="getChatMsgHistory"
      @comment="openComment"
      @comentResult="handleCommentResult"
      @cite="handleQuoteMsg"
    />
    <chat-input
      ref="chatInputRef"
      :style-config="props.serviceStyle"
      :session-status="page.sessionStatus"
      :session-error="page.sessionError"
      :orgId="props.appInfo.orgId"
      :show-type="props.showType"
      :robot-enable="props.robotEnable"
      :close-session-enable="props.closeSessionEnable"
      :round="page.msgRound"
      :invite="page.invite"
      :cust-info="props.custInfo"
      :agent-info="page.agentInfo"
      @sendMsg="sendMsg"
      @comment="openComment"
      @quit="closeSession"
      @reconnnect="reconnnectService"
      @leaveMsg="openLeaveMsg"
      @sendCurrentMsg="handleSendCurrentMsg"
      @sendError="handleSendError"
      @guide="handleGuide"

      @seer="handleServiceSeer"
      @upload="handlePasteUpload"
      @cite="handleQuoteMsg"
    />

    <chat-comment
      ref="chatCommentRef"
      :style-config="props.serviceStyle"
      :orgId="props.appInfo.orgId"
      :show-type="props.showType"
    />
    <chat-leave-msg
      ref="chatLeaveMsgRef"
      :session-status="page.sessionStatus"
      :custInfo="props.custInfo"
      :orgId="props.appInfo.orgId"
      @confirm="confrimLeaveMsg"
    />

    <!-- 上传文件 -->
    <chat-upload :agent-info="page.agentInfo" ref="pasteUploadRef" @send="handlePasteUploadSend" />
  </div>
</template>

<script setup>
import ChatHeader from './ChatHeader.vue'
import ChatMsg from './ChatMsg.vue'
import ChatInput from './ChatInput.vue'
import ChatComment from './ChatComment.vue'
import ChatLeaveMsg from './ChatLeaveMsg.vue'
import ChatUpload from './ChatUpload.vue'
import { defineProps, reactive, getCurrentInstance, defineEmits, defineExpose, computed, ref, nextTick } from 'vue'
import { getReferrer, isJSON } from '@/utils/index'
import { ElMessage } from 'element-plus'
const props = defineProps({
  custInfo: { type: Object, default: () => {} }, //客户信息
  appInfo: { type: Object, default: () => {} }, //应用信息
  clientInfo: { type: Object, default: () => {} }, //客户端信息
  serviceStyle: { type: Object, default: () => {} }, //在线客服样式
  showType: { type: Number, default: 1 }, //1接入机器人 2接入客服
  closeSessionEnable: { type: Boolean, default: true }, //是否可以关闭在线客服会话
  robotEnable: { type: Boolean, default: true } //是否接入机器人
})
const emit = defineEmits(['switch', 'reconnect', 'quitChat', 'reconnnectService'])
const { proxy } = getCurrentInstance()
const query = reactive({
  openTime: new Date().getTime(),
  pageNo: 0,
  pageSize: 20
})
const page = reactive({
  msgList: [], //历史聊天记录
  transferType: 2, //转接类型 0-人转人，1-机转人，2-点击
  loading: 0,
  sessionStatus: 0,
  agentInfo: {}, //座席信息
  sessionError: false, //会话异常
  inviteType: 0, //邀请评价类型
  msgRound: 0, //消息回合
  msgRoundList: [], //消息类型回合
  invite: false,
  seerFlag: false
})
const chatMsg = computed(() => {
  return {
    loading: page.loading,
    list: page.msgList
  }
})
// 建立连接
const initWs = (content = null, msgContentType = null) => {
  proxy.$ws.init({
    url: props.appInfo.url,
    appId: props.appInfo.appId,
    appName: props.appInfo.appName,
    orgId: props.appInfo.orgId,
    userId: props.custInfo.custId,
    userName: props.custInfo.custName,
    userHeadImg: props.custInfo.custAvatar,
    userGroup: props.custInfo.groupId || null,
    content: content,
    msgContentType: msgContentType,
    openid: props.custInfo.openid,
    mobile: props.custInfo.mobile,
    lastServiceAgentId: props.custInfo.lastServiceAgentId,
    lastServiceAgentTime: props.custInfo.lastServiceAgentTime,
    tags: props.custInfo.tags,
    transferType: page.transferType,
    clientId: props.clientInfo.clientId,
    clientType: props.clientInfo.clientType,
    clientIp: props.clientInfo.clientIp,
    clientIpRegion: props.clientInfo.clientIpRegion,
    clientOs: props.clientInfo.clientOs,
    clientBrowse: props.clientInfo.clientBrowse,
    online: props.custInfo.online,
    sourceSite: getReferrer(),
    connectSuccess: (retryFlag) => {
      // 断线重连后需要处理的
      // if (retryFlag) {
      // }
      // 连接成功
      connectSuccessHandle()
    },
    connectClose: (data) => {
      console.log('connectClose -------回调 ')
      // 连接关闭
      if (data) {
        // 断线重连超出设定次数，提示用户
        ElMessage.error('消息服务断开，请检查网络设置')
      }
      wsConnectClose(data)
    },
    accessSuccess: (msg) => {
      // 客户连接成功
      custAccessSuccessHandle(msg)
    },
    agentAccessMsgReceived: (msg) => {
      // 坐席分配成功
      agentAccessSuccessHandle(msg)
    },
    chatMsgReceived: (msg) => {
      // 接收聊天消息
      chatMsgReceivedHandle(msg)
    },
    responseMsgReceived: (msg) => {
      // 接受应答消息
      responseMsgReceivedHandle(msg)
    },
    cancelMsgReceived: (msg) => {
      // 消息撤回
      cancelMsgReceivedHandle(msg)
    },
    sessionOverMsgReceived: (msg) => {
      // 会话结束
      sessionOverMsgReceivedHandle(msg)
    },
    agentChangeMsgReceived: (msg) => {
      // 转接坐席
      agentChangeMsgReceivedHandle(msg)
    },
    waitMsgReceived: (msg) => {
      // 排队
      waitMsgReceivedHandle(msg)
    },
    inviteCommentReceived: (msg) => {
      // 邀请评价消息
      inviteCommentReceivedHandle(msg)
    },
    sessionErrorReceived: (msg) => {
      // 会话异常
      sessionErrorReceivedHandle(msg)
    }
  })
}
const connectSuccessHandle = () => {
  if (proxy.$ws.retryCount > 0) {
    // 获取历史聊天记录
    query.pageNo = 0
    query.openTime = new Date().getTime()
    page.loading = 0
    page.msgList = []
    getChatMsgHistory().finally(() => {
      scrollToBottom()
    })
    getSessionStatus().then((data) => {
      if (!data) return
      let oldStatus = null
      if (data?.length === 0) {
        oldStatus = 1
      } else if (data[0].agentNetStatus === 0) {
        //网络异常
        oldStatus = 2
        page.sessionError = true
      } else if (data[0].agentNetStatus === 1) {
        // 网络正常
        oldStatus = 2
      }
      if (oldStatus) {
        if (oldStatus === 1) {
          // 机器人状态
          switchRobot()
        } else {
          // 转在线客服
          emit('reconnect')
        }
      }
    })
  }
}

const getSessionStatus = () => {
  return new Promise((resolve, reject) => {
    proxy.$http
      .post('/app/custClient/getSessionList', { custId: props.custInfo.custId, orgId: props.appInfo.orgId })
      .then((res) => {
        if (res.code === 0) {
          resolve(res.data)
        } else {
          reject([])
          ElMessage.error(res.msg)
        }
      })
  })
}

const wsConnectClose = async () => {
  console.log('wsConnectClose -------回调--------- ')
  page.sessionError = false
  page.sessionStatus = 0
  page.seerFlag = false
}
const custAccessSuccessHandle = (msg) => {
  // 客户连接成功
  page.sessionStatus = 1
  let oldSessionId = localStorage.getItem('sessionId') || null
  let newSessionId = proxy.$ws.sessionInfo.sessionId
  if (newSessionId !== oldSessionId) {
    page.msgList.push({
      ...msg,
      value: 1, //系统信息
      text: msg.msg || '连接成功，等待系统分配客服',
      time: msg.timestamp || new Date().getTime(),
      isLast: true
    })
    scrollToBottom()
  }
  // 询前引导语重置
  page.invite = false
}
const agentAccessSuccessHandle = (msg) => {
  // 座席分配成功
  page.sessionStatus = 2
  page.agentInfo = {
    agentId: msg.agentId,
    agentName: msg.agentName,
    agentHeadImg: msg.agentHeadImg,
    employeeNum: msg.employeeNum
  }
  let oldSessionId = localStorage.getItem('sessionId') || null
  let newSessionId = proxy.$ws.sessionInfo.sessionId
  if (newSessionId !== oldSessionId) {
    if (msg.msgType === 4 && msg.responseMsgType !== 6) { 
      page.msgList.push({
        ...msg,
        value: 2, //客服信息
        type: 1,
        text: msg.greeting,
        time: msg.timestamp,
        headePortrait: msg.agentHeadImg,
        msgContentType: 20,
        systemMsgType: 4
      })
      scrollToBottom()
    }
    // 缓存sessionId
    localStorage.setItem('sessionId', newSessionId)
  }
}
const sessionErrorReceivedHandle = (msg) => {
  // 会话异常
  page.sessionError = msg.state === 0 ? true : false
}
const chatMsgReceivedHandle = (msg) => {
  // toType:2客户 1客服
  let data = {
    value: msg.toType === 2 ? 3 : 2,
    text: msg.content,
    type: msg.msgContentType,
    msgId: msg.msgId,
    obj: isJSON(msg.content) ? JSON.parse(msg.content) : {},
    time: msg.timestamp,
    headePortrait: msg.toType == 2 ? props.custInfo.custAvatar : page.agentInfo.agentHeadImg,
    quoteMsgId: msg?.quoteMsgId,
    quoteMsgContent: msg.quoteMsgContent ? JSON.parse(msg.quoteMsgContent) : {},
    source: msg.source,
    fromName: msg.fromName || '',
    toName: msg.toName || ''
  }
  let index = page.msgList.findIndex((i) => i.msgId === msg.msgId * 1)
  if (index !== -1) {
    data.time = page.msgList[index].time
    page.msgList[index] = data
  } else {
    page.msgList.push(data)
  }
  scrollToBottom() // 滚动到底部
  if (props.serviceStyle.commentStyle.timeLimit.enabled === 1) {
    page.msgRoundList.push(msg.toType === 2 ? 3 : 2)
    JudgeMsgRound()
  }
}
// 判断消息回合
const JudgeMsgRound = () => {
  // 判断有几回合
  let arr1 = page.msgRoundList.filter((i) => i === 2)
  let arr2 = page.msgRoundList.filter((i) => i === 3)
  let min = arr1.length > arr2.length ? arr2.length : arr1.length
  if (min > 0) {
    arr1.splice(0, min)
    arr2.splice(0, min)
    page.msgRound += min
    page.msgRoundList = [...arr1, ...arr2]
    arr1 = null
    arr2 = null
  }
  min = null
}
// 发送图片消息
const handleSendCurrentMsg = (type, msgId, content) => {
  let data = {
    value: 3,
    text: '',
    type: type,
    msgId: msgId,
    obj: content,
    time: new Date().getTime(),
    headePortrait: props.custInfo.custAvatar
  }
  page.msgList.push(data)
  scrollToBottom() // 滚动到底部
}
// 图片消息发送失败
const handleSendError = (msgId) => {
  let index = page.msgList.findIndex((i) => i.msgId === msgId)
  if (index !== -1) {
    page.msgList.splice(index, 1)
  }
}
const responseMsgReceivedHandle = (msg) => {
  if (msg.responseMsgType === proxy.$ws.msgType.commentMsg || msg.responseMsgType === 6 || msg.responseMsgType === 26) {
    // 评价消息 6 会话超时前提示 23接入/转接提示
    page.msgList.push({
      ...msg,
      value: 1, //系统信息
      text: msg.msg,
      type: 1,
      time: msg.timestamp || new Date().getTime()
    })
    scrollToBottom()
  } else if (msg.responseMsgType === proxy.$ws.msgType.notInServiceTimeMsg) {
    // 不在服务时间
    page.sessionStatus = 3
    page.msgList.push({
      ...msg,
      value: 1, //系统信息
      text: msg.msg,
      type: 1,
      time: msg.timestamp || new Date().getTime()
    })
  } else if (msg.responseMsgType === proxy.$ws.msgType.blackMsg) {
    // 黑名单消息
    page.msgList.push({
      ...msg,
      value: 1, //系统信息
      text: msg.msg,
      type: 1,
      time: msg.timestamp || new Date().getTime()
    })
    scrollToBottom()
  } else if (msg.responseMsgType === 22) {
    // 会话邀请
    page.msgList.push({
      ...msg,
      value: 1, //系统信息
      text: msg.msg,
      type: 1,
      time: msg.timestamp || new Date().getTime()
    })
    page.invite = true
    // 关闭链接
    proxy.$ws.close()
  }
}
// 咨询前引导语重新接入
const handleGuide = (content, msgContentType) => {
  initWs(content, msgContentType)
  page.msgList.push({
		"value": 3,
		"type": msgContentType,
		"text": content,
		"time": new Date().getTime(),
		"headePortrait": props.custInfo.custAvatar,
		"fromName": props.custInfo.custName,
	})
}
// 消息撤回
const cancelMsgReceivedHandle = (msg) => {
  let index = page.msgList.findIndex((i) => i.msgId === msg.msgId)
  if (index !== -1) {
    let text
    if (page.msgList[index].value === 3) {
      text = '你撤回了一条消息'
    } else {
      text = `客服${page.agentInfo.agentName || ''}撤回了一条消息`
    }
    page.msgList.push({
      value: 1, //系统消息
      text: text,
      type: 1,
      time: msg.timestamp || new Date().getTime()
    })
    page.msgList.splice(index, 1)
    index = null
    text = null
  }
}
const sessionOverMsgReceivedHandle = async (msg) => {
  page.sessionStatus = 0
  page.sessionError = false
  // 会话结束
  page.msgList.push({
    value: 0, //历史消息
    type: 1,
    text: msg.overContent,
    time: msg.timestamp || new Date().getTime()
  })
  scrollToBottom() // 滚动到底部
}
// 转接消息
const agentChangeMsgReceivedHandle = (msg) => {
  page.agentInfo = {
    agentId: msg.newAgentId,
    agentName: msg.newAgentName,
    agentHeadImg: msg.newAgentHeadImg,
    employeeNum: msg.newEmployeeNum
  }
  page.msgList.push({
    ...msg,
    value: 1, //客服信息
    type: 1,
    text: msg.greeting,
    time: msg.timestamp,
    headePortrait: msg.agentHeadImg
  })
  scrollToBottom() // 滚动到底部
}
// 排队
const waitMsgReceivedHandle = (msg) => {
  page.msgList.push({
    ...msg,
    value: 1, //系统信息
    text: msg.msg || '您好，当前正在排队，请简单描述您的问题',
    type: 1,
    time: msg.timestamp || new Date().getTime()
  })
  scrollToBottom() // 滚动到底部
  if (msg.toLeave) {
    // 转留言
    openLeaveMsg()
  }
}
// 获取历史消息
const getChatMsgHistory = (callback) => {
  return new Promise((resolve) => {
    // if (page.loading !== 0) return
    page.loading = 1
    query.pageNo++
    let params = {
      orgId: props.appInfo.orgId,
      appId: props.appInfo.appId,
      custId: props.custInfo.custId,
      lastMsgDate: query.openTime,
      pageNo: query.pageNo,
      pageSize: query.pageSize
    }
    console.log(params)
    proxy.$http
      .post('/app/custClient/chatmsg/history', params)
      .then((res) => {
        if (res.code === 0) {
          let { list, currPage, totalCount } = res.data
          if (currPage === Math.ceil(totalCount / query.pageSize) || list.length === 0) {
            page.loading = 2
          } else {
            page.loading = 0
          }
          list.forEach((item) => {
            const obj = {
              ...item,
              value: item.toType + 1,
              type: item.msgContentType,
              text: item.content,
              time: item.timestamp,
              headePortrait: item.fromHeadImg || '',
              obj: isJSON(item.content) ? JSON.parse(item.content) : {},
              quoteMsgId: item?.quoteMsgId,
              quoteMsgContent: item.quoteMsgContent ? JSON.parse(item.quoteMsgContent) : {},
              source: item.source,
              fromName: item.fromName || '',
              toName: item.toName || ''
            }
            // 需要特殊处理的系统消息
            if (obj.type == 20) {
              if (item.systemMsgType === 4) { 
                obj.value = 2
                obj.headePortrait = page.agentInfo.agentHeadImg
                obj.fromName = page.agentInfo.agentName
              } else {
                obj.value = 5
              }
            }
            page.msgList.push(obj)
          })
          if (callback) {
            nextTick(() => {
              callback(list.length)
            })
          }
          resolve(list.length)
        } else {
          ElMessage.error(res.msg)
        }
      })
      .catch(() => {
        page.loading = 0
        ElMessage.error('网络连接异常，请稍候再试')
      })
  })
}
// 邀请评价
const inviteCommentReceivedHandle = (msg) => {
  // 邀请评价类型
  page.inviteType = msg.inviteType
  page.msgList.push({
    ...msg,
    value: 2,
    text: msg.msg,
    type: 12,
    headePortrait: page.agentInfo.agentHeadImg,
    time: msg.timestamp || new Date().getTime()
  })
  scrollToBottom() // 滚动到底部
}

const reconnnectService = () => {
  emit('reconnnectService')
}
// 开启会话
const openSession = () => {
  // 获取历史聊天记录
  query.pageNo = 0
  query.openTime = new Date().getTime()
  page.loading = 0
  page.msgList = []
  getChatMsgHistory().finally(() => {
    scrollToBottom()
  })
  initWs()
}
// 结束会话
const closeSession = () => {
  proxy.$ws.sendSessionOverMsg()
  emit('quitChat')
}
// 发送消息
const sendMsg = (msg, msgId) => {
  if (proxy.$ws.status === 0) {
    ElMessage.error('网络未连接成功，请检查您的网络设置')
  } else if ([1, 2].includes(proxy.$ws.status)) {
    ElMessage.error('您还未分配坐席，请稍候')
  } else if (proxy.$ws.status == 4) {
    // 开启会话
    emit('reconnnectService')
  } else {
    let { type, content, url, quoteMsgId, quoteMsgContent } = msg
    const agentHeadImg = page.agentInfo.agentHeadImg || ''
    proxy.$ws.sendChatMsg(page.agentInfo.agentId, msgId || new Date().getTime(), type, content, url, agentHeadImg, quoteMsgId, quoteMsgContent)
    // 滚动条最底
    scrollToBottom()
  }
}
// 留言
const chatLeaveMsgRef = ref(null)
const openLeaveMsg = () => {
  chatLeaveMsgRef.value.open()
}
// 评价
const chatCommentRef = ref(null)
const openComment = () => {
  chatCommentRef.value.open(page.inviteType)
}
// 回显留言
const confrimLeaveMsg = (arg) => { 
  // let msg = {
  //   realName: arg.name,
  //   mobile: arg.mobile,
  //   msgContent: arg.message
  // }
  // page.msgList.push({
  //   value: 3, //回显留言
  //   text: JSON.stringify(msg),
  //   type: 11,
  //   obj: arg,
  //   time: new Date().getTime(),
  //   headePortrait: props.custInfo.custAvatar
  // })
  // scrollToBottom()
}
// 转机器人
const switchRobot = () => {
  localStorage.removeItem('robotId')
  if (proxy.$ws.status === 3) {
    closeSession()
  }
  if (proxy.$ws.status !== 0) {
    proxy.$ws.close()
  }
  // 转机器人
  emit('switch')
}
const chatMsgRef = ref(null)
const scrollToBottom = () => {
  chatMsgRef.value && chatMsgRef.value.scrollToBottom()
}
const init = (serr) => {
  page.msgRound = 0
  page.msgRoundList = []

  page.sessionStatus = 0
  page.sessionError = serr || false
  // 获取历史消息
  query.pageNo = 0
  query.lastMsgDate = new Date().getTime()
  page.loading = 0
  page.msgList = []
  getChatMsgHistory().then(() => {
    scrollToBottom()
  })
  // 初始化socket
  initWs()
}

// 服务先知
const handleServiceSeer = (msg) => {
  if (proxy.$ws.status === 3) {
    let { type, content, url } = msg
    proxy.$ws.seerMsg(page.agentInfo.agentId, new Date().getTime(), type, content, url)
  }
}

// 引用
const chatInputRef = ref()
const handleQuoteMsg = (data) => {
  chatInputRef.value && chatInputRef.value.handleSetInputMsg(data)
}


const pasteUploadRef = ref(null)
const isUpload = ref(false)
const uploading = ref(false)
// 复制图片或文件发送
const handlePasteUpload = async (e) => {
  let files = e?.dataTransfer?.files || e
  let arr = ['jpeg,jpg,gif,png,webp,ico', 'pdf,ppt,pptx,txt,xls,xlsx,doc,docx', 'mp4,webm,ts,avi,mov,wmv,m4v']
  let fileType = getFileExtension(files[0].name)
  // 判断文件格式
  let flag = arr.some((i) => i.includes(fileType))
  if (!flag) {
    ElMessage.error('请上传符合格式的文件！')
    isUpload.value = false
    return
  }
  let type
  if (files[0].type.includes('image')) {
    type = 3
  } else if (files[0].type.includes('video')) {
    type = 6
  } else {
    type = 4
  }
  // 判断文件大小
  let size = files[0].size / 1024 / 1024
  if (type === 3 && size > 10) {
    isUpload.value = false
    return ElMessage.error(`上传的文件不能大于10MB！`)
  }
  if (type === 4 && size > 10) {
    isUpload.value = false
    return ElMessage.error(`上传的文件不能大于10MB！`)
  }
  if (type === 6 && size > 10) {
    isUpload.value = false
    return ElMessage.error(`上传的文件不能大于10MB！`)
  }
  // 上传图片
  uploading.value = true
  startPasteUploadTimer()
  const formData = new FormData()
  formData.append('file', files[0])
  let res = await proxy.$http.post(`${proxy.$config.baseURL}/sys/oss/upload`, formData, {
    headers: { 'Content-type': 'multipart/form-data' }
  })
  if (res && res.code === 0) {
    ElMessage.success('上传成功！')
    pasteUploadRef.value.init({ file: { ...res.data }, type})
  } else {
    ElMessage.error('上传失败！')
  }
  handleCancelUpload()
}

// 复制文件或图片发送
const handlePasteUploadSend = (data) => {
  nextTick(() => {
    chatInputRef.value.copyConten(data)
  })
}


// 取消复制上传上传
const handleCancelUpload = () => {
  clearPasteUploadTimer()
  percentage.value = 0
  uploading.value = false
  isUpload.value = false
}

// 获取并返回文件后缀
const getFileExtension = (filename) => {
  const parts = filename.split('.')
  return parts.pop()
};

// 复制上传定时器
const pasteUploadTimer = ref(null);
const percentage = ref(0);
const startPasteUploadTimer = () => {
  clearPasteUploadTimer()
  setInterval(() => {
    if (percentage.value < 98) {
      percentage.value++
    }
  }, 1000)
}

// 清理复制上传的定时器
const clearPasteUploadTimer = () => {
  if (pasteUploadTimer.value) {
    clearInterval(timer.value)
    pasteUploadTimer.value = null
  }
}

defineExpose({
  initWs,
  openSession,
  init
})
</script>

<style lang="less" scoped>
.service-session {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
